import { ShieldCheck, Globe2, Lock } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { useParametres } from "@/hooks/useParametres";
import { useSeo } from "@/hooks/useSeo";
import { truncate } from "@/lib/seo";



function AboutPage() {
  const { t } = useI18n();
  const { data: parametres } = useParametres();
  const titre = parametres?.["pages.about.titre"];
  const intro = parametres?.["pages.about.corps"];

  useSeo({
    title: `${titre || t("about.heading")} — Ramba News`,
    description: truncate(intro || t("about.intro")),
    path: "/about",
  });

  const cards = [
    { icon: ShieldCheck, titleKey: "about.card.verified.title", bodyKey: "about.card.verified.body" },
    { icon: Lock, titleKey: "about.card.sources.title", bodyKey: "about.card.sources.body" },
    { icon: Globe2, titleKey: "about.card.multilingual.title", bodyKey: "about.card.multilingual.body" },
  ];

  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-10 md:py-14">
      <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-verified">{t("nav.about")}</div>
      <h1 className="mt-2 font-serif text-3xl md:text-5xl font-semibold tracking-tight">
        {titre || t("about.heading")}
      </h1>

      <p className="mt-6 text-lg leading-relaxed text-foreground whitespace-pre-wrap">
        {intro || t("about.intro")}
      </p>

      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {cards.map((c) => (
          <div key={c.titleKey} className="rounded-md border border-border bg-card p-5">
            <c.icon className="h-5 w-5 text-verified" />
            <h3 className="mt-3 text-base font-semibold">{t(c.titleKey)}</h3>
            <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">{t(c.bodyKey)}</p>
          </div>
        ))}
      </div>

      <h2 className="mt-14 font-serif text-2xl font-semibold">{t("about.approach.title")}</h2>
      <p className="mt-3 text-base leading-relaxed text-foreground/90">
        {t("about.approach.body")}
      </p>
    </div>
  );
}

export default AboutPage;
